<section>
    <div class="title">
        <h2 *ngIf="selectedPlanData">{{ pageHeader }}</h2>
    </div>
    <xm-plan-switch-review *ngIf="eligiblePlanDetails && (!user.account.isSegmentFive || (!enablePlanSevenResi && !enablePlanSevenCBM))" [pageData]="planSwitchReviewPageData" 
        [selectedPlanEligibilityData]="eligiblePlanDetails" [selectedPlanData]="selectedPlanData" [features]="features" (navigationObject)="navigateTo($event)" [isLevel5Customer]="summary.level5Customer" [lineSummary]="lineSummary"></xm-plan-switch-review>
    <xm-plan-switch-review *ngIf="enablePlanSevenResi || enablePlanSevenCBM" [enablePlanSevenResi]="enablePlanSevenResi" [enablePlanSevenCBM]="enablePlanSevenCBM"></xm-plan-switch-review>
</section>
